module.exports = __webpack_public_path__ + "static/phone-image-24098092977fc52df122fff96fd337c7.png";